<template>
<div :class="['number-input', { inline: inline }]">
    <input type="text" v-model="number" :placeholder="placeholder" :disabled="isDisabled" @keydown="filterInput" @input="validateNumber" @blur="formatNumber">
</div>
</template>
<script>
export default {
    name: 'number-input',
    props: {
        value: {
            type: [Number, String],
            required: false,
        },
        decimals: {
            type: [Number, String],
            required: false,
            default: 2
        },
        min: {
            type: [Number, String],
            required: false,
        },
        max: {
            type: [Number, String],
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        disabled: {
            type: [Boolean, String, Number],
            required: false,
            default: false
        },
        inline: {
            type: [Boolean, String],
            required: false,
            default: false
        }
    },
    data() {
        return {
            number: '',
            valid: false,
            allowedCharCodes: [8,9,37,39,46] // backspace, del, arrows
        }
    },
    computed: {
        isDisabled() {
            return this.disabled != 0 && this.disabled != ''
        }
    },
    created() {
        if (this.decimals > 0) {
            this.allowedCharCodes.push(110, 190)
        }
        this.number = this.value
    },
    methods: {
        filterInput(event) {
			let charCode = (event.which) ? event.which : event.keyCode;
            //48 - 57 (pc keys, mac keys, mac keypad)
            //96 - 105 (pc keypad num lock on)
			if ((charCode < 48 || (charCode > 57 && charCode < 96) || charCode > 105) && !this.allowedCharCodes.includes(charCode)) {
				event.preventDefault()
				return
			}
            // disallow if they hit period / decimal and there's already a decimal
            if ((charCode == 110 || charCode == 190) && this.number.indexOf('.') > -1) {
				event.preventDefault()
				return
            }
        },
        validateNumber() {
            this.valid = false
            let numberParts = this.number.split('.')
            if (numberParts[1] && this.decimals > 0 && numberParts[1].length > this.decimals) {
                this.number = this.number.slice(0, -1)
				return
            }
            this.valid = true
        },
        formatNumber() {
            if (!this.number) {
                this.$emit('input', this.number)
                return false
            }
            if (this.decimals > 0) {
                let numberParts = this.number.split('.')
                if (numberParts[1] && numberParts[0].length == 0) {
                    this.number = '0.' + numberParts[1]
                }
                if (!numberParts[1] && numberParts[0].length > 0) {
                    this.number += '.'
                    this.number = this.number.padEnd(this.number.length + this.decimals, '0')
                } else if (numberParts[1].length < this.decimals && numberParts[0].length > 0) {
                    this.number = this.number.padEnd(this.number.length + (this.decimals - numberParts[1].length) , '0')
                }
            }
            if (this.min && this.number < this.min) {
                this.number = this.min
            }
            if (this.max && Number(this.number) > Number(this.max)) {
                this.number = this.max
            }
            this.$emit('input', this.number)
        }
    }
}
</script>

<style lang="scss" scoped>
.number-input {
    input[type="text"] { max-width: 7em; }
}
.inline {
    display: inline-block;
}
</style>
